const autofit = {
    init(options = {
        designWidth: 1920,
        designHeight: 929,
        renderDom: '#app',
        resize: true
    }, isShowInitTip = true) {
        if (isShowInitTip) {
            // console.log(`%c` + `vue-autofit` + ` is running`, `color: #fff; background: #f40; padding: 2px 4px; border-radius: 4px;`);
        }
        let designWidth = options.designWidth;
        let designHeight = options.designHeight;
        let renderDom = options.renderDom;
        let resize = options.resize;
        document.querySelector(renderDom).style.height = `${designHeight}px`;
        document.querySelector(renderDom).style.width = `${designWidth}px`;
        document.querySelector(renderDom).style.transformOrigin = `0 0`;
        keepFit(designWidth, designHeight, renderDom);
        resize && (window.onresize = () => {
            keepFit(designWidth, designHeight, renderDom);
        })
    }
}
function keepFit(designWidth, designHeight, renderDom) {
    let clientHeight = document.documentElement.clientHeight;
    let clientWidth = document.documentElement.clientWidth;
    let scale = 1;
    if (clientWidth / clientHeight < designWidth / designHeight) {
        scale = (clientWidth / designWidth)
        document.querySelector(renderDom).style.height = `${clientHeight / scale}px`;
    } else {
        scale = (clientHeight / designHeight)
        document.querySelector(renderDom).style.width = `${clientWidth / scale}px`;
    }
    document.querySelector(renderDom).style.transform = `scale(${scale})`;
    localStorage.setItem("scale", scale);
}
export default autofit;


// WEBPACK FOOTER //
// ./src/utils/autofit.js